/**
 * Deep-link filter utilities.
 * Reads ?filters=wlai-<base64json> from the URL on first mount and converts
 * it to a plain filter object.
 */

const AI_FILTER_PREFIX = 'wlai-';

function decodeBase64Safe(input: string): string {
  try {
    return atob(input);
  } catch {
    const b64 = input.replace(/-/g, '+').replace(/_/g, '/');
    const pad = b64.length % 4;
    return atob(pad ? b64 + '='.repeat(4 - pad) : b64);
  }
}

function getFiltersFromUrl(): Record<string, unknown> {
  try {
    const urlParams = new URLSearchParams(window.location.search);
    const filtersParam = urlParams.get('filters');

    if (filtersParam && filtersParam.startsWith(AI_FILTER_PREFIX)) {
      const base64 = filtersParam.substring(AI_FILTER_PREFIX.length);
      const decoded: unknown = JSON.parse(decodeBase64Safe(base64));
      if (decoded !== null && typeof decoded === 'object' && !Array.isArray(decoded)) {
        return decoded as Record<string, unknown>;
      }
    }
    const historyState = (window.history?.state?.usr ?? {}) as Record<string, unknown>;
    return historyState;
  } catch {
    return {};
  }
}

export function consumeUrlFilters(): Record<string, unknown> {
  const filters = getFiltersFromUrl();
  if (Object.keys(filters).length > 0 && window.location.search.includes('filters=')) {
    window.history.replaceState(
      { ...window.history.state, usr: filters },
      '',
      window.location.pathname
    );
  }
  return filters;
}
